class PlotBand {

	constructor(name) {
		this.config = {
			range: [0, 0],
			name
		};
	}

	range(range) {
		this.config.range = range;
		return this;
	}

}

export function plotBand(name) {
	return new PlotBand(name);
}



// WEBPACK FOOTER //
// ./utils/panelgraph/components/plot-band.js